import { useNavigate, useSearchParams } from "react-router";
import { Card } from "../UI/Card.tsx";
import { useProductInfo } from "./useProductInfo.ts";
import { FullPageLoading } from "../UI/FullPageLoading.tsx";
import { NavBar } from "../UI/Layout/NavBar.tsx";
import { Layout } from "../UI/Layout/Layout.tsx";
import { MainContainer } from "../UI/Layout/MainContainer.tsx";
import { useCreatePaymentIntent } from "./useCreatePaymentIntent.ts";
import { useAnalyticsParams } from "./useAnalyticsParams.ts";
import { useMoneyTransferInfoQueryStringRepository } from "./useMoneyTransferInfoQueryStringRepository.ts";
import { DisplayMoneyTransferInfoScreenPath } from "./DisplayMoneyTransferInfoScreen.tsx";
import {
  NoInvoiceMoneyTransferForm,
  NoInvoiceMoneyTransferFormParams,
} from "./NoInvoiceMoneyTransferForm.tsx";
import { useToMoneyTransferWithInvoice } from "./useToMoneyTransferWithInvoice.ts";
import { Link } from "../UI/Link.tsx";
import { Footer } from "../UI/Layout/Footer.tsx";

export const NoInvoiceMoneyTransferScreenPath = `/money-transfer`;

function NoInvoiceMoneyTransferScreenInternal({
  priceId,
  productId,
}: {
  priceId: string;
  productId: string;
}) {
  const { productInfo, loading } = useProductInfo({
    productId,
    priceId,
  });

  const { createPaymentIntent } = useCreatePaymentIntent();
  const { analyticsParams } = useAnalyticsParams();
  const navigate = useNavigate();
  const { decorateUrlWithEncodedMoneyTransferInfo } =
    useMoneyTransferInfoQueryStringRepository();

  const { toMoneyTransferWithInvoice } = useToMoneyTransferWithInvoice();
  if (loading) return <FullPageLoading />;
  if (!productInfo) return null; //TODO implementare 404

  async function onSubmit(data: NoInvoiceMoneyTransferFormParams) {
    const moneyTransferInfo = await createPaymentIntent({
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      priceId,
      productId,
      ...analyticsParams,
    });

    const url = decorateUrlWithEncodedMoneyTransferInfo(
      moneyTransferInfo,
      new URL(DisplayMoneyTransferInfoScreenPath, window.location.origin),
    );

    navigate(`${url.pathname}${url.search}`);
  }
  return (
    <Layout>
      <NavBar />
      <MainContainer>
        <div className={"w-full max-w-[500px]"}>
          <Card>
            <div>
              <div className={"mb-4 flex flex-col space-y-1"}>
                <h3 className={"font-bold text-xl"}>
                  {productInfo.productName}
                </h3>
                <p>{productInfo.unitAmount / 100}€</p>
                <p>
                  Compila il form qui sotto per ricevere le informazioni per
                  procedere al bonifico
                </p>
                <p className={"mt-2"}>
                  Ti serve la fattura? Clicca{" "}
                  <Link
                    label={"qui"}
                    onClick={(e) => {
                      e.preventDefault();
                      toMoneyTransferWithInvoice({ productId, priceId });
                    }}
                  />
                </p>
              </div>
              <NoInvoiceMoneyTransferForm onSubmit={onSubmit} />
            </div>
          </Card>
        </div>
      </MainContainer>
      <Footer />
    </Layout>
  );
}

export function NoInvoiceMoneyTransferScreen() {
  const [searchParams] = useSearchParams();
  const priceId = searchParams.get("priceId");
  const productId = searchParams.get("productId");
  if (!priceId || !productId) return <p>Missing price or product id</p>; //TODO implementare 404;
  return (
    <NoInvoiceMoneyTransferScreenInternal
      priceId={priceId}
      productId={productId}
    />
  );
}
